var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticStyle:{"margin-top":"5em"},attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"8","cols":"11"}},[_c('h4',[_vm._v("The page you are looking for does not exist")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }